
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import TestimonialsHeroSection from './components/TestimonialsHeroSection';
import FeaturedCaseStudiesSection from './components/FeaturedCaseStudiesSection';
import ClientReviewsSection from './components/ClientReviewsSection';
import SuccessNumbersSection from './components/SuccessNumbersSection';
import TestimonialsCTASection from './components/TestimonialsCTASection';

export default function TestimonialsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <TestimonialsHeroSection />
        <FeaturedCaseStudiesSection />
        <ClientReviewsSection />
        <SuccessNumbersSection />
        <TestimonialsCTASection />
      </main>
      <Footer />
    </div>
  );
}
